<template>
  <div>
    <div class="p-3 bg-white rounded-xl shadow-lg mx-4">
      <div class="grid grid-cols-2" @click="showFilters = !showFilters">
        <div class="flex items-center gap-4">
          <a-icon type="filter" class="text-lg ml-2"></a-icon>
          <h2 class="text-left text-lg text-gray-600">
            <b>Filtros de búsqueda</b>
          </h2>
        </div>
        <span
          class="h-5 w-5 m-2 flex justify-center items-center transition justify-self-end"
          :class="{ 'transform rotate-180': showFilters }"
        >
          <a-icon type="caret-down" class="text-xl my-auto" />
        </span>
      </div>
      <a-divider v-if="showFilters" class="mt-2 mb-2"></a-divider>
      <div
        class="flex gap-5 flex-wrap relative w-full border-box"
        v-show="showFilters"
      >
        <form id="filterCompainesEmisoras" @submit.prevent="submitForm">
          <div
            class="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2 relative"
          >
            <BaseSelect
              ref="name"
              id="name"
              label="Nombre"
              :selectOptions="formOptions.optionsCompanyEmisor"
              v-model="form.name"
              :loading="loading"
            />
            <BaseInput
              type="text"
              label="NIT"
              placeholder="Ej: 123456789"
              v-model="form.nit"
            />
            <BaseSelect
              ref="company_emisores_type"
              id="identification"
              label="Tipo de entidad"
              :selectOptions="formOptions.optionsEntityType"
              v-model="form.company_emisores_type"
              :loading="loading"
            />
            <BaseNumber
              label="Código"
              placeholder="Ej: 12"
              v-model="form.code"
            />
            <BaseSelect
              ref="control-vigilado"
              id="control-vigilado"
              label="Control / Vigilado"
              :selectOptions="formOptions.optionsMannedCheckpoint"
              v-model="form.company_emisores_control"
              :loading="loading"
            />
            <BaseSelect
              ref="is_active"
              id="estado"
              label="Estado"
              :selectOptions="statusOptions"
              v-model="form.is_active"
              :loading="loading"
            />
          </div>

          <div class="w-full flex justify-end self-end gap-4 mt-5 mb-3">
            <a-button
              class="w-1/2 gap-2 sm:mt-auto mt-3 lg:w-1/6"
              type="primary"
              ghost
              shape="round"
              @click="clearFilters"
            >
              Limpiar
            </a-button>
            <a-button
              :disabled="searching ? true : false"
              type="primary"
              shape="round"
              @click="submitForm"
              class="w-1/2 gap-2 sm:mt-auto mt-3 lg:w-1/6"
            >
              <a-icon type="search" v-if="!searching"></a-icon>
              {{ searching ? "BUSCANDO..." : "BUSCAR" }}
            </a-button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import {
  DEFAULT_PAGE,
  DEFAULT_PAGE_SIZE,
} from "../../../../../core/utils/constants";

export default {
  props: ["loading", "searching"],
  data() {
    return {
      form: {
        name: "",
        nit: "",
        company_emisores_type: "",
        code: "",
        company_emisores_control: "",
        is_active: "",
      },
      showFilters: false,
      statusOptions: [
        { id: 1, name: "Activo" },
        { id: 2, name: "Inactivo" },
      ],
    };
  },
  created() {
    this.initializeForm();
  },
  async mounted() {
    const pagination = {
      page: DEFAULT_PAGE,
      pageSize: DEFAULT_PAGE_SIZE,
    };
    console.log(this.form);

    this.$emit("getFilterForm", this.form, pagination);
  },
  methods: {
    getNameById(lista, idBuscado, defaultValue = null) {
      try {
        const elementoEncontrado = lista.find(
          (elemento) => String(elemento.id) === String(idBuscado),
        );
        if (elementoEncontrado) {
          return elementoEncontrado.name;
        }
      } catch (error) {
        console.error(
          "getNameById - error:",
          error,
          "lista",
          lista,
          "idBuscado",
          idBuscado,
        );
      }
      return defaultValue;
    },
    async submitForm() {
      const entidad_emisor_nombre = this.getNameById(
        this.formOptions.optionsCompanyEmisor,
        this.form.name,
      );
      this.form.name = entidad_emisor_nombre ? entidad_emisor_nombre : this.form.name;

      const pagination = {
        page: DEFAULT_PAGE,
        pageSize: DEFAULT_PAGE_SIZE,
      };

      this.$emit("getFilterForm", this.form, pagination);
    },
    async clearFilters() {
      this.initializeForm();

      const pagination = {
        page: DEFAULT_PAGE,
        pageSize: DEFAULT_PAGE_SIZE,
      };

      this.$emit("getFilterForm", this.form, pagination);
    },
    initializeForm() {
      this.form = {
        name: "",
        nit: "",
        company_emisores_type: "",
        code: "",
        company_emisores_control: "",
        is_active: "",
      };
    },
  },
  computed: {
    formOptions: function () {
      return this.$store.state.form;
    },
  },
};
</script>

<style>
#filterCompainesEmisoras {
  width: 100%;
}
</style>
